import { Component, computed, effect, OnInit} from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatToolbarModule } from "@angular/material/toolbar";
import { NavigationTitleContainerComponent } from "./navigation-title-container/navigation-title-container.component";
import { KnownSteps } from "../../../shared/models/session.model";
import { DirectSessionLogicService } from "../../../shared/direct-session-logic.service";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject, combineLatest } from "rxjs";
import { LayoutChangeService } from "../../../shared/layout-change.service";
import { StepState } from "../../../shared/models/step.model";


@Component({
  selector: "navigation-position-bar",
  template: `
    <div
      class="scrollable-container flex breadcrumb-bar px-5 gap-2 mt-6 text-base font-medium tracking-normal leading-6 text-center text-white max-md:flex-wrap "
      style="display: flex; justify-content: center; align-items: center; flex-direction: row; width: 100%;"
      >
      @for(step of knownSteps; track step.index){
        <app-navigation-title-container
          [step]="step.index"
          class="flex flex-row items-center"
        >
          </app-navigation-title-container>
      }

    </div>

  `,
  styleUrls: ["./navigation-position-bar.component.scss"],
  standalone: true,
  imports: [ 
    RouterModule, 
    MatToolbarModule , 
    NavigationTitleContainerComponent, 
    CommonModule
  ],

})

export class NavigationPositionBarComponent implements OnInit {

  isMobile: boolean = false;

  completedSteps : number =0;
  maxSteps : number = this.knownSteps.length -1;

  currentPageNumber: string = "";
  currentPageBreadCrumb: string = "";

  constructor(
    public directSessionLogic: DirectSessionLogicService,
    private responsive: BreakpointObserver,
    private layoutChangeService: LayoutChangeService
  ) {

    effect(() => {
      this.currentPageNumber = this.directSessionLogic.currentStepSignal().toString();
      this.currentPageBreadCrumb = this.directSessionLogic.knownStepsListSignal()[this.directSessionLogic.currentStepSignal()].breadcrumbName;
    });
  }

  stepsFedFromSignal(index: number) {
    let individualStep = computed(() => this.directSessionLogic.knownStepsListSignal()[index]);
    return individualStep();
  } 
  
  get stepsList(): StepState[] {
    return this.directSessionLogic.stepsListSignal();
  }

  get knownSteps(): KnownSteps[] {
    return this.directSessionLogic.knownStepsListSignal();
  }
  get thisStepRef(): KnownSteps {
    return this.directSessionLogic.knownStepsListSignal()[this.stepIndex];
  }
  get stepIndex(): number {
    return this.directSessionLogic.currentStepSignal();
  }


  ngOnInit(){
    this.responsive.observe([
      Breakpoints.XSmall //, Breakpoints.Small
      ])
      .subscribe(result => {
        this.isMobile = false; 
        if (result.matches) 
          this.isMobile = true;      
    });

  }


  ngOnChanges() {
    this.directSessionLogic.generateKnownStepsListSignal();
  }


}